@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-425_991_515)
internal val Res.string.audit_date_placeholder: StringResource by lazy {
      StringResource("string:audit_date_placeholder", "audit_date_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6312, 46),
      ))
    }

@delegate:ResourceContentHash(1_333_835_362)
internal val Res.string.audit_details_title: StringResource by lazy {
      StringResource("string:audit_details_title", "audit_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6359, 55),
      ))
    }

@delegate:ResourceContentHash(-1_362_564_590)
internal val Res.string.audit_empty: StringResource by lazy {
      StringResource("string:audit_empty", "audit_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6415, 55),
      ))
    }

@delegate:ResourceContentHash(-1_638_939_969)
internal val Res.string.audit_export: StringResource by lazy {
      StringResource("string:audit_export", "audit_export", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6471, 32),
      ))
    }

@delegate:ResourceContentHash(-120_265_308)
internal val Res.string.audit_filter_all: StringResource by lazy {
      StringResource("string:audit_filter_all", "audit_filter_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6504, 32),
      ))
    }

@delegate:ResourceContentHash(-687_030_632)
internal val Res.string.audit_filter_custom: StringResource by lazy {
      StringResource("string:audit_filter_custom", "audit_filter_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6537, 47),
      ))
    }

@delegate:ResourceContentHash(-1_451_219_714)
internal val Res.string.audit_filter_month: StringResource by lazy {
      StringResource("string:audit_filter_month", "audit_filter_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6585, 34),
      ))
    }

@delegate:ResourceContentHash(1_513_343_243)
internal val Res.string.audit_filter_week: StringResource by lazy {
      StringResource("string:audit_filter_week", "audit_filter_week", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6620, 37),
      ))
    }

@delegate:ResourceContentHash(-848_025_591)
internal val Res.string.audit_invalid_date_range: StringResource by lazy {
      StringResource("string:audit_invalid_date_range", "audit_invalid_date_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6658, 152),
      ))
    }

@delegate:ResourceContentHash(1_243_385_766)
internal val Res.string.audit_result_failure: StringResource by lazy {
      StringResource("string:audit_result_failure", "audit_result_failure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6811, 36),
      ))
    }

@delegate:ResourceContentHash(2_343_909)
internal val Res.string.audit_result_none: StringResource by lazy {
      StringResource("string:audit_result_none", "audit_result_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6848, 29),
      ))
    }

@delegate:ResourceContentHash(-321_181_903)
internal val Res.string.audit_result_success: StringResource by lazy {
      StringResource("string:audit_result_success", "audit_result_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6878, 40),
      ))
    }

@delegate:ResourceContentHash(-989_284_405)
internal val Res.string.audit_retry: StringResource by lazy {
      StringResource("string:audit_retry", "audit_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6919, 43),
      ))
    }

@delegate:ResourceContentHash(-1_228_325_340)
internal val Res.string.audit_search_placeholder: StringResource by lazy {
      StringResource("string:audit_search_placeholder", "audit_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6963, 96),
      ))
    }

@delegate:ResourceContentHash(-987_076_131)
internal val Res.string.audit_title: StringResource by lazy {
      StringResource("string:audit_title", "audit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7060, 31),
      ))
    }

@delegate:ResourceContentHash(-2_116_406_483)
internal val Res.string.auth_access_app: StringResource by lazy {
      StringResource("string:auth_access_app", "auth_access_app", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7179, 51),
      ))
    }

@delegate:ResourceContentHash(-1_554_460_157)
internal val Res.string.auth_access_app_helper: StringResource by lazy {
      StringResource("string:auth_access_app_helper", "auth_access_app_helper", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7092, 86),
      ))
    }

@delegate:ResourceContentHash(1_653_478_375)
internal val Res.string.auth_change_password: StringResource by lazy {
      StringResource("string:auth_change_password", "auth_change_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7231, 48),
      ))
    }

@delegate:ResourceContentHash(2_132_773_787)
internal val Res.string.auth_confirm_new_password: StringResource by lazy {
      StringResource("string:auth_confirm_new_password", "auth_confirm_new_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7280, 61),
      ))
    }

@delegate:ResourceContentHash(1_153_380_725)
internal val Res.string.auth_corporate_email: StringResource by lazy {
      StringResource("string:auth_corporate_email", "auth_corporate_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7342, 52),
      ))
    }

@delegate:ResourceContentHash(1_153_380_725)
internal val Res.string.auth_email: StringResource by lazy {
      StringResource("string:auth_email", "auth_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7395, 42),
      ))
    }

@delegate:ResourceContentHash(-1_062_242_228)
internal val Res.string.auth_forgot_password: StringResource by lazy {
      StringResource("string:auth_forgot_password", "auth_forgot_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8025, 56),
      ))
    }

@delegate:ResourceContentHash(-443_667_254)
internal val Res.string.auth_forgot_password_code_description: StringResource by lazy {
      StringResource("string:auth_forgot_password_code_description", "auth_forgot_password_code_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7438, 101),
      ))
    }

@delegate:ResourceContentHash(-1_042_963_962)
internal val Res.string.auth_forgot_password_email_description: StringResource by lazy {
      StringResource("string:auth_forgot_password_email_description", "auth_forgot_password_email_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7540, 194),
      ))
    }

@delegate:ResourceContentHash(1_800_156_154)
internal val Res.string.auth_forgot_password_email_error: StringResource by lazy {
      StringResource("string:auth_forgot_password_email_error", "auth_forgot_password_email_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7735, 112),
      ))
    }

@delegate:ResourceContentHash(39_179_313)
internal val Res.string.auth_forgot_password_password_description: StringResource by lazy {
      StringResource("string:auth_forgot_password_password_description", "auth_forgot_password_password_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7848, 113),
      ))
    }

@delegate:ResourceContentHash(-1_062_242_228)
internal val Res.string.auth_forgot_password_title: StringResource by lazy {
      StringResource("string:auth_forgot_password_title", "auth_forgot_password_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7962, 62),
      ))
    }

@delegate:ResourceContentHash(1_440_284_694)
internal val Res.string.auth_hello_collaborator: StringResource by lazy {
      StringResource("string:auth_hello_collaborator", "auth_hello_collaborator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8082, 59),
      ))
    }

@delegate:ResourceContentHash(17_570_107)
internal val Res.string.auth_invalid_credentials: StringResource by lazy {
      StringResource("string:auth_invalid_credentials", "auth_invalid_credentials", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8142, 68),
      ))
    }

@delegate:ResourceContentHash(-1_650_301_315)
internal val Res.string.auth_login: StringResource by lazy {
      StringResource("string:auth_login", "auth_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8297, 26),
      ))
    }

@delegate:ResourceContentHash(346_390_472)
internal val Res.string.auth_login_failed: StringResource by lazy {
      StringResource("string:auth_login_failed", "auth_login_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8211, 85),
      ))
    }

@delegate:ResourceContentHash(-875_434_443)
internal val Res.string.auth_missing_credentials: StringResource by lazy {
      StringResource("string:auth_missing_credentials", "auth_missing_credentials", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8324, 72),
      ))
    }

@delegate:ResourceContentHash(230_881_323)
internal val Res.string.auth_network_error: StringResource by lazy {
      StringResource("string:auth_network_error", "auth_network_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8397, 102),
      ))
    }

@delegate:ResourceContentHash(-1_663_740_013)
internal val Res.string.auth_new_password: StringResource by lazy {
      StringResource("string:auth_new_password", "auth_new_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8500, 41),
      ))
    }

@delegate:ResourceContentHash(1_813_653_306)
internal val Res.string.auth_password: StringResource by lazy {
      StringResource("string:auth_password", "auth_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9239, 29),
      ))
    }

@delegate:ResourceContentHash(287_682_391)
internal val Res.string.auth_password_changed_success: StringResource by lazy {
      StringResource("string:auth_password_changed_success", "auth_password_changed_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8542, 73),
      ))
    }

@delegate:ResourceContentHash(1_881_887_049)
internal val Res.string.auth_password_mismatch_error: StringResource by lazy {
      StringResource("string:auth_password_mismatch_error", "auth_password_mismatch_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8616, 72),
      ))
    }

@delegate:ResourceContentHash(-296_430_870)
internal val Res.string.auth_password_omit: StringResource by lazy {
      StringResource("string:auth_password_omit", "auth_password_omit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8689, 46),
      ))
    }

@delegate:ResourceContentHash(-1_823_981_749)
internal val Res.string.auth_password_requirements_error: StringResource by lazy {
      StringResource("string:auth_password_requirements_error", "auth_password_requirements_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8736, 96),
      ))
    }

@delegate:ResourceContentHash(-60_705_317)
internal val Res.string.auth_password_rule_lowercase: StringResource by lazy {
      StringResource("string:auth_password_rule_lowercase", "auth_password_rule_lowercase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8833, 76),
      ))
    }

@delegate:ResourceContentHash(1_001_788_941)
internal val Res.string.auth_password_rule_min_length: StringResource by lazy {
      StringResource("string:auth_password_rule_min_length", "auth_password_rule_min_length", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8910, 69),
      ))
    }

@delegate:ResourceContentHash(-1_499_023_769)
internal val Res.string.auth_password_rule_no_spaces: StringResource by lazy {
      StringResource("string:auth_password_rule_no_spaces", "auth_password_rule_no_spaces", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8980, 72),
      ))
    }

@delegate:ResourceContentHash(-1_924_506_864)
internal val Res.string.auth_password_rule_number: StringResource by lazy {
      StringResource("string:auth_password_rule_number", "auth_password_rule_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9053, 61),
      ))
    }

@delegate:ResourceContentHash(843_886_692)
internal val Res.string.auth_password_rule_uppercase: StringResource by lazy {
      StringResource("string:auth_password_rule_uppercase", "auth_password_rule_uppercase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9115, 76),
      ))
    }

@delegate:ResourceContentHash(1_017_324_627)
internal val Res.string.auth_password_show: StringResource by lazy {
      StringResource("string:auth_password_show", "auth_password_show", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9192, 46),
      ))
    }

@delegate:ResourceContentHash(-1_672_220_348)
internal val Res.string.auth_remember_me: StringResource by lazy {
      StringResource("string:auth_remember_me", "auth_remember_me", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9269, 40),
      ))
    }

@delegate:ResourceContentHash(1_522_940_317)
internal val Res.string.auth_reset_code_expired_error: StringResource by lazy {
      StringResource("string:auth_reset_code_expired_error", "auth_reset_code_expired_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9310, 97),
      ))
    }

@delegate:ResourceContentHash(838_972_137)
internal val Res.string.auth_reset_code_failed_error: StringResource by lazy {
      StringResource("string:auth_reset_code_failed_error", "auth_reset_code_failed_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9408, 108),
      ))
    }

@delegate:ResourceContentHash(-2_126_636_368)
internal val Res.string.auth_reset_code_invalid_error: StringResource by lazy {
      StringResource("string:auth_reset_code_invalid_error", "auth_reset_code_invalid_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9517, 97),
      ))
    }

@delegate:ResourceContentHash(-864_417_836)
internal val Res.string.auth_reset_failed_error: StringResource by lazy {
      StringResource("string:auth_reset_failed_error", "auth_reset_failed_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9615, 103),
      ))
    }

@delegate:ResourceContentHash(-470_112_167)
internal val Res.string.auth_reset_session_expired_error: StringResource by lazy {
      StringResource("string:auth_reset_session_expired_error", "auth_reset_session_expired_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9719, 104),
      ))
    }

@delegate:ResourceContentHash(-1_051_254_660)
internal val Res.string.auth_reset_too_many_attempts_error: StringResource by lazy {
      StringResource("string:auth_reset_too_many_attempts_error", "auth_reset_too_many_attempts_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9824, 130),
      ))
    }

@delegate:ResourceContentHash(255_812_966)
internal val Res.string.auth_send_email: StringResource by lazy {
      StringResource("string:auth_send_email", "auth_send_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9955, 43),
      ))
    }

@delegate:ResourceContentHash(994_759_523)
internal val Res.string.auth_validate_code: StringResource by lazy {
      StringResource("string:auth_validate_code", "auth_validate_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9999, 46),
      ))
    }

@delegate:ResourceContentHash(-747_396_985)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10046, 20),
      ))
    }

@delegate:ResourceContentHash(-1_616_227_455)
internal val Res.string.companies_action_activate: StringResource by lazy {
      StringResource("string:companies_action_activate", "companies_action_activate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10067, 41),
      ))
    }

@delegate:ResourceContentHash(-497_509_869)
internal val Res.string.companies_action_deactivate: StringResource by lazy {
      StringResource("string:companies_action_deactivate", "companies_action_deactivate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10109, 47),
      ))
    }

@delegate:ResourceContentHash(-1_972_891_150)
internal val Res.string.companies_action_details: StringResource by lazy {
      StringResource("string:companies_action_details", "companies_action_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10157, 44),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.companies_action_edit: StringResource by lazy {
      StringResource("string:companies_action_edit", "companies_action_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10202, 37),
      ))
    }

@delegate:ResourceContentHash(1_151_430_244)
internal val Res.string.companies_add: StringResource by lazy {
      StringResource("string:companies_add", "companies_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10240, 45),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.companies_cancel: StringResource by lazy {
      StringResource("string:companies_cancel", "companies_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10286, 36),
      ))
    }

@delegate:ResourceContentHash(122_745_712)
internal val Res.string.companies_cep_loading: StringResource by lazy {
      StringResource("string:companies_cep_loading", "companies_cep_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10323, 53),
      ))
    }

@delegate:ResourceContentHash(1_539_054_651)
internal val Res.string.companies_col_actions: StringResource by lazy {
      StringResource("string:companies_col_actions", "companies_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10377, 41),
      ))
    }

@delegate:ResourceContentHash(1_827_621_969)
internal val Res.string.companies_col_direction: StringResource by lazy {
      StringResource("string:companies_col_direction", "companies_col_direction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10419, 43),
      ))
    }

@delegate:ResourceContentHash(-681_040_982)
internal val Res.string.companies_col_legal_name: StringResource by lazy {
      StringResource("string:companies_col_legal_name", "companies_col_legal_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10463, 52),
      ))
    }

@delegate:ResourceContentHash(1_323_502_045)
internal val Res.string.companies_col_management: StringResource by lazy {
      StringResource("string:companies_col_management", "companies_col_management", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10516, 44),
      ))
    }

@delegate:ResourceContentHash(-1_696_824_886)
internal val Res.string.companies_col_trade_name: StringResource by lazy {
      StringResource("string:companies_col_trade_name", "companies_col_trade_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10561, 52),
      ))
    }

@delegate:ResourceContentHash(1_350_968_497)
internal val Res.string.companies_col_type: StringResource by lazy {
      StringResource("string:companies_col_type", "companies_col_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10614, 34),
      ))
    }

@delegate:ResourceContentHash(-1_049_962_070)
internal val Res.string.companies_col_updated_at: StringResource by lazy {
      StringResource("string:companies_col_updated_at", "companies_col_updated_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10649, 60),
      ))
    }

@delegate:ResourceContentHash(-741_962_950)
internal val Res.string.companies_col_updated_by: StringResource by lazy {
      StringResource("string:companies_col_updated_by", "companies_col_updated_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10710, 48),
      ))
    }

@delegate:ResourceContentHash(-497_509_869)
internal val Res.string.companies_deactivate_confirm: StringResource by lazy {
      StringResource("string:companies_deactivate_confirm", "companies_deactivate_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10759, 48),
      ))
    }

@delegate:ResourceContentHash(57_575_472)
internal val Res.string.companies_deactivate_msg: StringResource by lazy {
      StringResource("string:companies_deactivate_msg", "companies_deactivate_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10808, 92),
      ))
    }

@delegate:ResourceContentHash(-2_143_166_412)
internal val Res.string.companies_deactivate_title: StringResource by lazy {
      StringResource("string:companies_deactivate_title", "companies_deactivate_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10901, 58),
      ))
    }

@delegate:ResourceContentHash(1_241_612_738)
internal val Res.string.companies_details_title: StringResource by lazy {
      StringResource("string:companies_details_title", "companies_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10960, 59),
      ))
    }

@delegate:ResourceContentHash(-2_027_207)
internal val Res.string.companies_empty: StringResource by lazy {
      StringResource("string:companies_empty", "companies_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11020, 59),
      ))
    }

@delegate:ResourceContentHash(-1_638_939_969)
internal val Res.string.companies_export: StringResource by lazy {
      StringResource("string:companies_export", "companies_export", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11080, 36),
      ))
    }

@delegate:ResourceContentHash(534_471_829)
internal val Res.string.companies_field_admin_others_percent: StringResource by lazy {
      StringResource("string:companies_field_admin_others_percent", "companies_field_admin_others_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11117, 108),
      ))
    }

@delegate:ResourceContentHash(-504_461_509)
internal val Res.string.companies_field_button_count: StringResource by lazy {
      StringResource("string:companies_field_button_count", "companies_field_button_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11226, 64),
      ))
    }

@delegate:ResourceContentHash(2_461_946)
internal val Res.string.companies_field_cep: StringResource by lazy {
      StringResource("string:companies_field_cep", "companies_field_cep", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11291, 31),
      ))
    }

@delegate:ResourceContentHash(-242_237_128)
internal val Res.string.companies_field_city: StringResource by lazy {
      StringResource("string:companies_field_city", "companies_field_city", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11323, 36),
      ))
    }

@delegate:ResourceContentHash(678_943_887)
internal val Res.string.companies_field_cnpj: StringResource by lazy {
      StringResource("string:companies_field_cnpj", "companies_field_cnpj", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11360, 36),
      ))
    }

@delegate:ResourceContentHash(-1_988_866_955)
internal val Res.string.companies_field_comment_all_ratings: StringResource by lazy {
      StringResource("string:companies_field_comment_all_ratings", "companies_field_comment_all_ratings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11397, 103),
      ))
    }

@delegate:ResourceContentHash(-766_678_503)
internal val Res.string.companies_field_commercial_phone: StringResource by lazy {
      StringResource("string:companies_field_commercial_phone", "companies_field_commercial_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11501, 64),
      ))
    }

@delegate:ResourceContentHash(1_827_621_969)
internal val Res.string.companies_field_direction: StringResource by lazy {
      StringResource("string:companies_field_direction", "companies_field_direction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11566, 45),
      ))
    }

@delegate:ResourceContentHash(-957_383_799)
internal val Res.string.companies_field_email: StringResource by lazy {
      StringResource("string:companies_field_email", "companies_field_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11612, 37),
      ))
    }

@delegate:ResourceContentHash(-651_582_150)
internal val Res.string.companies_field_employee_count: StringResource by lazy {
      StringResource("string:companies_field_employee_count", "companies_field_employee_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11650, 74),
      ))
    }

@delegate:ResourceContentHash(-1_501_049_580)
internal val Res.string.companies_field_leftover_meals: StringResource by lazy {
      StringResource("string:companies_field_leftover_meals", "companies_field_leftover_meals", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11725, 62),
      ))
    }

@delegate:ResourceContentHash(-681_040_982)
internal val Res.string.companies_field_legal_name: StringResource by lazy {
      StringResource("string:companies_field_legal_name", "companies_field_legal_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11788, 54),
      ))
    }

@delegate:ResourceContentHash(-2_136_574_886)
internal val Res.string.companies_field_line: StringResource by lazy {
      StringResource("string:companies_field_line", "companies_field_line", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11843, 36),
      ))
    }

@delegate:ResourceContentHash(691_916_733)
internal val Res.string.companies_field_logo: StringResource by lazy {
      StringResource("string:companies_field_logo", "companies_field_logo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11880, 36),
      ))
    }

@delegate:ResourceContentHash(-385_608_345)
internal val Res.string.companies_field_long_auto_send_time: StringResource by lazy {
      StringResource("string:companies_field_long_auto_send_time", "companies_field_long_auto_send_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11917, 87),
      ))
    }

@delegate:ResourceContentHash(1_323_502_045)
internal val Res.string.companies_field_management: StringResource by lazy {
      StringResource("string:companies_field_management", "companies_field_management", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12005, 46),
      ))
    }

@delegate:ResourceContentHash(-1_876_203_835)
internal val Res.string.companies_field_mobile_phone: StringResource by lazy {
      StringResource("string:companies_field_mobile_phone", "companies_field_mobile_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12052, 48),
      ))
    }

@delegate:ResourceContentHash(-502_097_859)
internal val Res.string.companies_field_neighborhood: StringResource by lazy {
      StringResource("string:companies_field_neighborhood", "companies_field_neighborhood", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12101, 44),
      ))
    }

@delegate:ResourceContentHash(1_781_098_291)
internal val Res.string.companies_field_number: StringResource by lazy {
      StringResource("string:companies_field_number", "companies_field_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12146, 42),
      ))
    }

@delegate:ResourceContentHash(1_373_020_942)
internal val Res.string.companies_field_short_auto_send_time: StringResource by lazy {
      StringResource("string:companies_field_short_auto_send_time", "companies_field_short_auto_send_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12189, 88),
      ))
    }

@delegate:ResourceContentHash(-47_387_542)
internal val Res.string.companies_field_state: StringResource by lazy {
      StringResource("string:companies_field_state", "companies_field_state", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12278, 37),
      ))
    }

@delegate:ResourceContentHash(2_640_715)
internal val Res.string.companies_field_street: StringResource by lazy {
      StringResource("string:companies_field_street", "companies_field_street", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12316, 34),
      ))
    }

@delegate:ResourceContentHash(-1_696_824_886)
internal val Res.string.companies_field_trade_name: StringResource by lazy {
      StringResource("string:companies_field_trade_name", "companies_field_trade_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12351, 54),
      ))
    }

@delegate:ResourceContentHash(1_350_968_497)
internal val Res.string.companies_field_type: StringResource by lazy {
      StringResource("string:companies_field_type", "companies_field_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12406, 36),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("audit_date_placeholder", Res.string.audit_date_placeholder)
  map.put("audit_details_title", Res.string.audit_details_title)
  map.put("audit_empty", Res.string.audit_empty)
  map.put("audit_export", Res.string.audit_export)
  map.put("audit_filter_all", Res.string.audit_filter_all)
  map.put("audit_filter_custom", Res.string.audit_filter_custom)
  map.put("audit_filter_month", Res.string.audit_filter_month)
  map.put("audit_filter_week", Res.string.audit_filter_week)
  map.put("audit_invalid_date_range", Res.string.audit_invalid_date_range)
  map.put("audit_result_failure", Res.string.audit_result_failure)
  map.put("audit_result_none", Res.string.audit_result_none)
  map.put("audit_result_success", Res.string.audit_result_success)
  map.put("audit_retry", Res.string.audit_retry)
  map.put("audit_search_placeholder", Res.string.audit_search_placeholder)
  map.put("audit_title", Res.string.audit_title)
  map.put("auth_access_app", Res.string.auth_access_app)
  map.put("auth_access_app_helper", Res.string.auth_access_app_helper)
  map.put("auth_change_password", Res.string.auth_change_password)
  map.put("auth_confirm_new_password", Res.string.auth_confirm_new_password)
  map.put("auth_corporate_email", Res.string.auth_corporate_email)
  map.put("auth_email", Res.string.auth_email)
  map.put("auth_forgot_password", Res.string.auth_forgot_password)
  map.put("auth_forgot_password_code_description", Res.string.auth_forgot_password_code_description)
  map.put("auth_forgot_password_email_description", Res.string.auth_forgot_password_email_description)
  map.put("auth_forgot_password_email_error", Res.string.auth_forgot_password_email_error)
  map.put("auth_forgot_password_password_description", Res.string.auth_forgot_password_password_description)
  map.put("auth_forgot_password_title", Res.string.auth_forgot_password_title)
  map.put("auth_hello_collaborator", Res.string.auth_hello_collaborator)
  map.put("auth_invalid_credentials", Res.string.auth_invalid_credentials)
  map.put("auth_login", Res.string.auth_login)
  map.put("auth_login_failed", Res.string.auth_login_failed)
  map.put("auth_missing_credentials", Res.string.auth_missing_credentials)
  map.put("auth_network_error", Res.string.auth_network_error)
  map.put("auth_new_password", Res.string.auth_new_password)
  map.put("auth_password", Res.string.auth_password)
  map.put("auth_password_changed_success", Res.string.auth_password_changed_success)
  map.put("auth_password_mismatch_error", Res.string.auth_password_mismatch_error)
  map.put("auth_password_omit", Res.string.auth_password_omit)
  map.put("auth_password_requirements_error", Res.string.auth_password_requirements_error)
  map.put("auth_password_rule_lowercase", Res.string.auth_password_rule_lowercase)
  map.put("auth_password_rule_min_length", Res.string.auth_password_rule_min_length)
  map.put("auth_password_rule_no_spaces", Res.string.auth_password_rule_no_spaces)
  map.put("auth_password_rule_number", Res.string.auth_password_rule_number)
  map.put("auth_password_rule_uppercase", Res.string.auth_password_rule_uppercase)
  map.put("auth_password_show", Res.string.auth_password_show)
  map.put("auth_remember_me", Res.string.auth_remember_me)
  map.put("auth_reset_code_expired_error", Res.string.auth_reset_code_expired_error)
  map.put("auth_reset_code_failed_error", Res.string.auth_reset_code_failed_error)
  map.put("auth_reset_code_invalid_error", Res.string.auth_reset_code_invalid_error)
  map.put("auth_reset_failed_error", Res.string.auth_reset_failed_error)
  map.put("auth_reset_session_expired_error", Res.string.auth_reset_session_expired_error)
  map.put("auth_reset_too_many_attempts_error", Res.string.auth_reset_too_many_attempts_error)
  map.put("auth_send_email", Res.string.auth_send_email)
  map.put("auth_validate_code", Res.string.auth_validate_code)
  map.put("back", Res.string.back)
  map.put("companies_action_activate", Res.string.companies_action_activate)
  map.put("companies_action_deactivate", Res.string.companies_action_deactivate)
  map.put("companies_action_details", Res.string.companies_action_details)
  map.put("companies_action_edit", Res.string.companies_action_edit)
  map.put("companies_add", Res.string.companies_add)
  map.put("companies_cancel", Res.string.companies_cancel)
  map.put("companies_cep_loading", Res.string.companies_cep_loading)
  map.put("companies_col_actions", Res.string.companies_col_actions)
  map.put("companies_col_direction", Res.string.companies_col_direction)
  map.put("companies_col_legal_name", Res.string.companies_col_legal_name)
  map.put("companies_col_management", Res.string.companies_col_management)
  map.put("companies_col_trade_name", Res.string.companies_col_trade_name)
  map.put("companies_col_type", Res.string.companies_col_type)
  map.put("companies_col_updated_at", Res.string.companies_col_updated_at)
  map.put("companies_col_updated_by", Res.string.companies_col_updated_by)
  map.put("companies_deactivate_confirm", Res.string.companies_deactivate_confirm)
  map.put("companies_deactivate_msg", Res.string.companies_deactivate_msg)
  map.put("companies_deactivate_title", Res.string.companies_deactivate_title)
  map.put("companies_details_title", Res.string.companies_details_title)
  map.put("companies_empty", Res.string.companies_empty)
  map.put("companies_export", Res.string.companies_export)
  map.put("companies_field_admin_others_percent", Res.string.companies_field_admin_others_percent)
  map.put("companies_field_button_count", Res.string.companies_field_button_count)
  map.put("companies_field_cep", Res.string.companies_field_cep)
  map.put("companies_field_city", Res.string.companies_field_city)
  map.put("companies_field_cnpj", Res.string.companies_field_cnpj)
  map.put("companies_field_comment_all_ratings", Res.string.companies_field_comment_all_ratings)
  map.put("companies_field_commercial_phone", Res.string.companies_field_commercial_phone)
  map.put("companies_field_direction", Res.string.companies_field_direction)
  map.put("companies_field_email", Res.string.companies_field_email)
  map.put("companies_field_employee_count", Res.string.companies_field_employee_count)
  map.put("companies_field_leftover_meals", Res.string.companies_field_leftover_meals)
  map.put("companies_field_legal_name", Res.string.companies_field_legal_name)
  map.put("companies_field_line", Res.string.companies_field_line)
  map.put("companies_field_logo", Res.string.companies_field_logo)
  map.put("companies_field_long_auto_send_time", Res.string.companies_field_long_auto_send_time)
  map.put("companies_field_management", Res.string.companies_field_management)
  map.put("companies_field_mobile_phone", Res.string.companies_field_mobile_phone)
  map.put("companies_field_neighborhood", Res.string.companies_field_neighborhood)
  map.put("companies_field_number", Res.string.companies_field_number)
  map.put("companies_field_short_auto_send_time", Res.string.companies_field_short_auto_send_time)
  map.put("companies_field_state", Res.string.companies_field_state)
  map.put("companies_field_street", Res.string.companies_field_street)
  map.put("companies_field_trade_name", Res.string.companies_field_trade_name)
  map.put("companies_field_type", Res.string.companies_field_type)
}
